module.exports = __webpack_public_path__ + "static/img/loading-line-1.9ee3c55.png";